import Vue from 'vue';
import iView from 'iview';
import Router from 'vue-router'
import {routers} from './router'

Vue.use(Router);

// 路由配置
const RouterConfig = {
  // mode: 'history',
  routes: routers
};


let router = new Router(RouterConfig);

// 监听路由跳转前后 - 模拟进度条
router.beforeEach((to, from, next) => {
  iView.LoadingBar.start();
  next();
});

router.afterEach(route => {
  setTimeout(() => {
    iView.LoadingBar.finish();
  },500);
  if (document.getElementsByClassName('ivu-card-body')[0]) {
    document.getElementsByClassName('ivu-card-body')[0].scrollIntoView();
  }});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js